import { ChangeDetectionStrategy, Component } from '@angular/core';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { NTextComponent } from '../../common/text/text.component';
import { defaultImage } from '../../icms.config';

export namespace NCmsFeaturedPorducts {
    export interface IComponentData extends NICmsContentComponent.IData {
        blocks: IBlock[];
    }

    export interface IBlock extends NTextComponent.ITextContent {
        backgroundImage: string;
        imageLink?: string;
        variant?: '1-column' | '2-columns';
        overlay?: number;
    }
}
@ICmsComponent<CmsFeaturedProductsComponent>({
    id: 'featured-products',
    name: 'Featured products',
    tags: ['featured', 'products'],
    fields: [
        <NICmsContentField.IRepeaterField>{
            type: NICmsContentField.EFieldType.repeater,
            key: 'blocks',
            title: 'Blocks',
            itemName: 'Block',
            itemNameField: 'title',
            required: true,
            defaultSize: 4,
            maxSize: 6,
            fields: [
                ...NTextComponent.getFields(false, true, false),
                {
                    key: 'backgroundImage',
                    type: NICmsContentField.EFieldType.image,
                    title: 'Background image',
                    default: defaultImage,
                    required: true
                },
                {
                    key: 'imageLink',
                    type: NICmsContentField.EFieldType.text,
                    title: 'Image link'
                },
                {
                    key: 'variant',
                    type: NICmsContentField.EFieldType.choice,
                    title: 'Variant',
                    default: '1-column',
                    options: [
                        { key: '1-column', title: '1 Column' },
                        { key: '2-columns', title: '2 Columns' }
                    ]
                },
                {
                    key: 'overlay',
                    type: NICmsContentField.EFieldType.number,
                    title: 'Overlay',
                    min: 0,
                    max: 100,
                    default: 0
                }
            ]
        }
    ]
})
@Component({
    selector: 'featured-products',
    templateUrl: './cms-featured-products.html',
    styleUrls: ['./cms-featured-products.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CmsFeaturedProductsComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component?: NCmsFeaturedPorducts.IComponentData;
}
